/**
 * Teaser
 */
import { Component, registerComponent } from 'js/component.js';
import { isEditModeFooter } from 'js/helpers.js';
const componentName = 'teaser';

export class Teaser extends Component {
    static listenersRegistered = false;

    /**
     * Check if teaser is inside single column with siblings.
     * If it is, we need to ensure it displays correctly via class.
     */
    updateTeaserSiblings = () => {
        const parentCol = this.element.parentNode;

        if(parentCol) {
            for (let i = 0, l = parentCol.classList.length; i < l; i += 1) {
                if(/col-.*/.test(parentCol.classList[i])) {
                    const teasersInCol = parentCol.querySelectorAll(`.${componentName}`);
                    if(teasersInCol.length > 1) [...teasersInCol].map((teaser) => teaser.classList.add('vertical-sibling'));
                    break;
                }
            }
        }
    };

    matchTeaserImageHeights = () => {
        const rows = document.querySelectorAll('.row');

        rows.forEach((row) => {
            const teaserImages = row.querySelectorAll('.layout-vertical .teaser__image');

            // Skip if no images or only one image (no need to match heights)
            if (teaserImages.length <= 1) return;

            // Reset heights first
            Array.from(teaserImages).forEach((image) => {
                // Create a clone of the style object to avoid modifying the parameter directly
                const imgElement = image;
                imgElement.style.height = 'auto';
            });

            // Get tallest
            let maxHeight = 0;
            teaserImages.forEach((imgDiv) => {
                const height = imgDiv.offsetHeight;
                if (height > maxHeight) maxHeight = height;
            });

            // Apply tallest height only if we found a valid height
            if (maxHeight > 0) {
                Array.from(teaserImages).forEach((image) => {
                    // Create a clone of the style object to avoid modifying the parameter directly
                    const imgElement = image;
                    imgElement.style.height = `${maxHeight}px`;
                });
            }
        });
    };

    initTeaserHeightMatching = () => {
        if (Teaser.listenersRegistered) return;

        // Bind the method to preserve the correct 'this' context
        const boundMatchHeights = this.matchTeaserImageHeights.bind(this);

        window.addEventListener('load', () => {
            boundMatchHeights();
            // Backup for lazy images
            setTimeout(boundMatchHeights, 500);
        });

        window.addEventListener('resize', boundMatchHeights);

        Teaser.listenersRegistered = true;
    };

    /**
     * Initialize Component
     */
    init() {
        if(isEditModeFooter()) return;
        this.updateTeaserSiblings();
        this.initTeaserHeightMatching();
    }
}

registerComponent(`.${componentName}`, Teaser);
